import { LocalStorageDataAccess, StorageDataAccess, StorageRepository } from '@softline/core';
import { inject, Inject, Injectable } from '@angular/core';
import { DEVELOPER_LOCAL_STORAGE_KEY } from '../service/developer.service';
import { DeveloperConfig } from '../developer-config';


@Injectable({providedIn: 'root'})
export class DeveloperRepository extends StorageRepository<DeveloperConfig, undefined> {
  constructor() {
    super(inject(LocalStorageDataAccess), DEVELOPER_LOCAL_STORAGE_KEY);
  }
}
